import React from "react";
import Datatable from "../shared/dataTable";

const History = () => {
  return (
    <>
      <div className="history-wrapper ps-3">
        <Datatable />
      </div>
    </>
  );
};

export default History;
